/* eslint-disable @typescript-eslint/semi */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { DataCollectorService } from '../../../core/services/data_collector_services/data_collector_service.service';
import { UtilityService } from '../../../core/services/utility_functions/utility_functions.service';
import { concat, Observable, of, pipe, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, startWith, switchMap, tap } from 'rxjs/operators';
import { DateTimePipe } from '../../../core/pipes/datetimeformator.pipe';
import { AdditionalFilter, FilterField, FilterFieldOption, FilterOptionValue, GenerateFilterOptions,OperatorEn } from './advance-filter.interface';
import * as R from 'ramda';
import * as ld  from 'lodash';
import { TimeFormatPipe } from '../../../core/pipes/timeFormat.pipe';
import { FormControl, Validators } from '@angular/forms';
import { DateFormatPipe } from '../../../core/pipes/dateFormat.pipe';
import { SafeHtml } from '../../../core/pipes/safeHTML.pipe';
import { AdvanceFilterService } from './advance-filter.service';
import { LocalStorageService } from '../../../core/services/localstorage.service';
import { DataGridService } from '../../datagrid/datagrid.service';
import moment from 'moment';
import dayjs from 'dayjs';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import _ from 'lodash';
import {CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray} from '@angular/cdk/drag-drop';
import { TranslateService } from '@ngx-translate/core';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
ld.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
export const _filter = (opt: string[], value: string): string[] => {
    const filterValue = value.toLowerCase();
    return opt.filter(item => item.toLowerCase().includes(filterValue));
};
@Component({
    selector: 'advance-filter',
    templateUrl: './advance-filter.component.html',
    styleUrls: ['./advance-filter.component.scss'],
    changeDetection:ChangeDetectionStrategy?.OnPush
  })
  export class AdvanceFilterComponent implements OnInit, OnChanges {
    @Input() module: string = '';
    @Input() options: GenerateFilterOptions = {
        title:'Filter',
        footerClass: 'bottom-0',
        headerClass: 'mt-10'
    };
    @Input() hideHeaderFooter: boolean = false;
    @Input() filterOptionalValues: Array<FilterOptionValue> = [];
    @Input() filterFieldOptions: Array<FilterFieldOption> = [];
    @Input() additionalFilters?: AdditionalFilter;
    @Output() applyOrSaveFilter = new EventEmitter<any>();
    @ViewChild('fieldTypeField') fieldTypeField: ElementRef;
    @ViewChild('scroll', { read: ElementRef }) public scroll: ElementRef<any>;
    fieldKeys = [];
    ind = -1;
    lookupLoading: boolean = false;
    showNewForm: boolean=false;
    saveFilter: boolean=false;
    public date: moment.Moment;
    mockKeys: any[] = [];
    timeFormat: any = '12';
    dateFormat: 'DD/MM/YYYY';
    dateTimeFormat: 'DD/MM/YYYY HH:mm A';
    OperatorEn: any = {};
    readonly separatorKeysCodes = [ENTER, COMMA] as const;
    tagsSubmitted: boolean = false;
    pageSize: any = 1;
    totalPages: any = 0;
    currentField: any;
    currentSearchTerm: any;
    currentPreloadedValue: any = [];
    defaultTimesheetFilter: any = {};
    rangeFilter = {
        'SINGLE': this.defaultDateRange.filter((data: any)=> ['EMPTY','TODAY','TOMORROW','YESTERDAY','CUSTOM_DATE']?.includes(data?.rangeKey)),
        'BETWEEN': this.defaultDateRange.filter((data: any)=> !['TODAY','TOMORROW','YESTERDAY','CUSTOM_DATE']?.includes(data?.rangeKey))
    }
    rangeFilterOptions = {
        'SINGLE': this.defaultDateRange.filter((data: any)=> ['TODAY','TOMORROW','YESTERDAY','CUSTOM_DATE']?.includes(data?.rangeKey)),
        'BETWEEN': this.defaultDateRange.filter((data: any)=> !['EMPTY','TODAY','TOMORROW','YESTERDAY','CUSTOM_DATE']?.includes(data?.rangeKey))
    }
    constructor(private _dataCollectorService: DataCollectorService,
                public _utilityService: UtilityService,
                private timeFormatPipe: TimeFormatPipe,
                private dateTimePipe: DateTimePipe,
                private datePipe: DateFormatPipe,
                private zuperDrawerService: ZuperDrawerService,
                private safeHtml: SafeHtml,
                private dataGridService: DataGridService,
                private changeDetectorRef: ChangeDetectorRef,
                private advanceFilterService: AdvanceFilterService,
                private localStorageService: LocalStorageService,
                private translateService: TranslateService,
                private localisationService: LocalisationService){}
    ngOnInit(): void{
        this.localisationService.setDefaultLanguage();
        this.OperatorEn = OperatorEn;
        this.dateFormat = this._utilityService.dateFormat;
        this.dateTimeFormat = this._utilityService.dateTimeFormat;
        this.options = {
            showSaveFilter: true,
            isManageFilter: false,
            ...this.options
        };
        this.filterFieldOptions = this.filterFieldOptions?.map((data: any)=>{
            if(data.fieldType === 'LOOKUP'){
                data.data = {...data.data,listValue$:new Observable<any[]>()};
            };
            if(data.fieldType === 'MULTI_ITEM'){
                const optionValue = this.filterOptionalValues?.find((field: any)=> field?.key === data?.fieldDataKey);
                data.fieldOptions = data?.fieldOptions?.map((option: any)=> ({...option,checked: optionValue?.value.includes(option[this.getValueKey(data?.fieldDataKey)]) ? true : false}));
                if(data.fieldOptions.findIndex((opt: any)=> opt[this.getValueKey(data?.fieldDataKey)] === 'Select All') === -1){
                    data.fieldOptions = [{[this.getValueKey(data?.fieldDataKey)]:'Select All',[this.getDisplayKey(data?.fieldDataKey)]: 'Select All',checked: optionValue?.value?.length === data?.fieldOptions?.length ? true : false},...data.fieldOptions];
                }
            }
            data = {...data,operators:data?.operators?.map((opt: any)=>({...opt,displayLabel: opt.displayName ?? this.translateService.instant(OperatorEn[opt.displayValue])}))};
            return data;
        });
        this.filterOptionalValues = this.filterOptionalValues.filter((data: any)=> this.removeUnwantedFilters(data)).map((record: any,index)=> this.setPrepopulatedOptionalValue(record,index));
        // this.fieldKeys = this.filterFieldOptions?.map((data: any)=>({key:data.displayName,value:data.fieldDataKey, }));
        this.fieldKeys = this.filterFieldOptions?.map((data: any)=>({key:data.displayName,value:data.fieldDataKey, label: this._utilityService.getLocaleValue(data.displayKey, data.displayName)}));
        this.mockKeys = this.fieldKeys;
        this.setFilterComponentEmitValue('apply');
        this.triggerLookupPopulateValue();
        const timeFormat = {
            '12_HRS' : 12,
            '24_HRS' : 24
          };
        const userTimeFormat = this.localStorageService.getLocalStorage('user_preferences').time_format || 12;
        this.timeFormat = timeFormat[userTimeFormat];
        this.changeDetectorRef.markForCheck();
    }

    removeUnwantedFilters(data: any): boolean{
        if(data.module === 'TIMESHEET'){
            if(data?.key === 'checked_time'){
                this.defaultTimesheetFilter = data;
            }
          return !['',null,undefined].includes(data.key) && data.key !== 'checked_time';
        }
        return !['',null,undefined,'recurrence_job_uid','recurring_job_uid'].includes(data.key);
      }

    displayFn(field: any): string {
            return field ? this.fieldKeys?.find((data: any)=>data?.value === field)?.label : field;
    }

    setFilterRulesValue(rule): any{
        switch(this.getFieldType(rule.key)){
            case 'NUMBER':
            case 'DECIMAL':
                if(rule.operator === 'BETWEEN'){
                    return rule.value;
                }
                return Array.isArray(rule.value) ? rule.value[0] : rule.value;
            case 'DATE' :
                if(rule.operator === 'BETWEEN'){
                    const returnValue = []
                    if(!this._utilityService.isEmptyOrUndefined(rule.value[0])){
                        returnValue[0] = this._utilityService.formatDateTimeToStandard(rule.value[0],'YYYY-MM-DD','date');
                    }
                    if(!this._utilityService.isEmptyOrUndefined(rule.value[1])){
                        returnValue[1] = this._utilityService.formatDateTimeToStandard(rule.value[1],'YYYY-MM-DD','date');
                    }
                    return returnValue;
                }
                if(Array.isArray(rule.value)){
                    return this._utilityService.formatDateTimeToStandard(rule.value[0],'YYYY-MM-DD','date');
                }else{
                    return  this._utilityService.formatDateTimeToStandard(rule.value,'YYYY-MM-DD','date');
                }
            case 'DATETIME' :
                if(rule.operator === 'BETWEEN'){
                    return [this._utilityService.convertDate(rule.value[0],'YYYY-MM-DD HH:mm:ss','datetime'),this._utilityService.convertDate(rule.value[1],'YYYY-MM-DD HH:mm:ss','datetime')];
                }
                if(Array.isArray(rule.value)){
                    return  this._utilityService.convertDate(rule.value[0],'YYYY-MM-DD HH:mm:ss','datetime');
                }else{
                    return  this._utilityService.convertDate(rule.value,'YYYY-MM-DD HH:mm:ss','datetime');
                }
            case 'TIME' :
                if(rule.operator === 'BETWEEN'){
                    return [this._utilityService.formatDateTimeToStandard(rule.value[0],'HH:mm:ss','time'),this._utilityService.formatDateTimeToStandard(rule.value[1],'HH:mm:ss','time')];
                }
                if(Array.isArray(rule.value)){
                    return this._utilityService.formatDateTimeToStandard(rule.value[0],'HH:mm:ss','time');
                }else{
                    return this._utilityService.formatDateTimeToStandard(rule.value,'HH:mm:ss','time');
                }
            case 'MULTI_ITEM' :
               return rule?.value?.filter((data: any)=> data !== 'Select All');
            default:
                return rule.value;
        }
    }

    setFilterComponentEmitValue(action: string): void{
        let filter_rules = this.filterOptionalValues?.filter((data: any)=>data.key !== '').map((data: any,index)=>{
        const obj: any = {
            displayKeyValue:data.displayKeyValue,
            operatorDisplayKey:data.operatorDisplayKey,
            key: data.key,
            operator: data.operator ?? '',
            field_type: this.getFieldType(data.key),
            value : this.setFilterRulesValue(data),
            module: this.module,
            type: this.getTypeValue(data.key)
            };
            if(!this._utilityService.isEmptyOrUndefined(data?.rangeKey) && this.getFieldType(data.key) === 'DATE'){
                obj.rangeKey = data?.rangeKey
            }
            const filterKey = data?.filterKey ?? this.additionalFilters ?? {}
            if((!this._utilityService.isEmptyOrUndefined(filterKey) && Object.keys(filterKey)?.length > 0) && data.key === filterKey?.key){
                obj.filterKey = filterKey
            }
            return obj;
        });
        if(this.module === 'TIMESHEET'){
            filter_rules = [this.defaultTimesheetFilter,...filter_rules];
        }

        const filterObj = {
            action : action,
            module: this.module,
            saveFilter: this.saveFilter,
            filterRules: filter_rules
        };
        this.advanceFilterService.filterObj = filterObj;
        if(this.options?.data && this.options.data?.parentModule === 'dispatch') {
            const selectedDispatchTab = this.options.data.selectedDispatchTab;
            const module = this.options.data.module;
            this.advanceFilterService.updateDispatchFilterValue(selectedDispatchTab, module, filterObj?.filterRules);
        }
        this.changeDetectorRef.markForCheck();
    }

    toggleDrawer(drawerName,action: string): void{
        if(action === 'close' && this.localStorageService.getLocalStorage(`${this.module?.toLocaleLowerCase()}_filter_rules`) === '[]'){
            this.filterOptionalValues = [];
        }
        this.setFilterComponentEmitValue(action);
        const filterObj = this.advanceFilterService.filterObj;
        this.saveFilter = false;
        this.applyOrSaveFilter.emit(filterObj);
        const drawer = this.zuperDrawerService.getComponent(drawerName);
        drawer.close();
        this.changeDetectorRef.markForCheck();
      }

    setDate(picker,date): void {
        const newDate = date?.status.toLowerCase() === 'valid' ? date?.value : moment(new Date());
        picker.select(newDate);
        this.changeDetectorRef.markForCheck();
      }
    triggerLookupPopulateValue(index?): any{
        if(!this._utilityService.isEmptyOrUndefined(index) && this.filterOptionalValues && this.filterOptionalValues?.length && this.getFieldType(this.filterOptionalValues[index]?.key) === 'LOOKUP' && this.filterOptionalValues?.find((data: any)=>data?.value?.length > 0)){
            this.currentField = this.filterOptionalValues[index];
        }else{
            if(this.filterOptionalValues && this.filterOptionalValues?.length){
                const fields = this.filterOptionalValues?.filter((data: any)=> !['',null,undefined].includes(data.key) && !['',null,undefined].includes(data.operator) && (!['',null,undefined].includes(data.value) || !['',null,undefined].includes(data.value[0]) || !['',null,undefined].includes(data.value[1]))).map((data: any)=>data.key);
                fields.forEach((element: any) => {
                        if(this.getFieldType(element) === 'LOOKUP' && this.filterOptionalValues?.find((data: any)=>data.value.length > 0)){
                            this.presetInputList(this.filterOptionalValues?.find((data: any)=>data.key === element));
                        }
                });
            }
        }
    }

    addField(): void{
        const newObj = {
            key: '',
            operator: '',
            value: '',
            displayKeyValue:[],
            showForm:true
        };
        this.filterOptionalValues = [...this.filterOptionalValues,newObj];
        this.setFilterComponentEmitValue('apply');
        setTimeout(() => {
            const fieldTypeField = this.fieldTypeField.nativeElement;
            if(fieldTypeField){
                fieldTypeField.focus();
                fieldTypeField.value = '';
            }
        });
        if(this.filterOptionalValues?.length > 1){
            this.collapseOthers(this.filterOptionalValues?.length - 1);
        }
        this.changeDetectorRef.markForCheck();
    }

    collapseOthers(index: number): void{
        this.filterOptionalValues = this.filterOptionalValues?.map((field: any,ind)=>({...field,showForm:ind === index}));
        this.filterOptionalValues[index] = this.setPrepopulatedOptionalValue(this.filterOptionalValues[index],index);
        if(this.filterOptionalValues[index]?.key !== ''){
            this.triggerLookupPopulateValue(index);
        }
        this.changeDetectorRef.markForCheck();
    }

    collapseForm(index: number): void{
        this.filterOptionalValues = this.filterOptionalValues?.filter((data: any)=> this.conditionToFilterValue(data));
        this.currentField = this.filterOptionalValues[index];
        this.filterOptionalValues[index] = this.setPrepopulatedOptionalValue(this.filterOptionalValues[index],index);
        if(this.filterOptionalValues[index]?.key !== ''){
                this.triggerLookupPopulateValue(index);
            }
        this.setFilterComponentEmitValue('apply');
        this.filterOptionalValues[index].showForm = !this.filterOptionalValues[index].showForm;
        this.showNewForm=false;
        this.changeDetectorRef.markForCheck();
    }

    conditionToFilterValue(data): boolean{
        if(!this._utilityService.isEmptyOrUndefined(data?.key)){
            return true;
        }else{
            return false;
        }
    }

    removeField(index: any): void{
        this.filterOptionalValues = this.filterOptionalValues?.filter((data: any,i)=> i !== index);
        this.setFilterComponentEmitValue('apply');
        this.changeDetectorRef.markForCheck();
    }

    getOperatorsAlignedToField(field: any): any{
        const operators = this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field)?.operators;
        return operators;
    }

    getfieldValueAlignedToField(field: any): any{

        return this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field)?.fieldOptions;
    }

    getValueKey(field): any{
        return this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field)?.filterOptionKey;
    }

    getLookupValueKey(field): any {
        return this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field)?.data?.dataKey;
    }

    getDisplayKey(field): any{
        return this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field)?.fieldLabelKey;
    }

    getFieldType(field): any{
        return this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field)?.fieldType;
    }

    getListValue(field): any{
        return this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field)?.data?.listValue$;
    }

    getTypeValue(field): any{
        return this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field)?.type || 'default_field';
    }

    getLookUpBindValue(field): any{
        return this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field)?.data?.bindLabel;
    }

    getMultiSelectValue(field): boolean{
        return this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field)?.multiSelect || false;
    }

    getField(field): string{
        return this.fieldKeys.find((data: any)=> data.value === field)?.label;
    }

    getDisplayName(field): string{
        return this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field)?.displayName;
    }

    getIsLazyLoading(field): boolean{
        return this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field)?.data?.lazyLoad;
    }

    setPrepopulatedOptionalValue(field,index): any{
        const fieldType = this.getFieldType(field.key);
        switch(fieldType){
            case 'LOOKUP':
                if(!this._utilityService.isEmptyOrUndefined(field?.value)){
                    field = {...field,valueSubject$:new Subject<string | null>()};
                }else{
                    this.pageSize = 1;
                    field = {...field,valueSubject$:new Subject<string | null>(),displayKeyValue:[],listPreData:[]};
                    if(this.getFieldType(field.key) === 'LOOKUP'){
                        this.currentField = field;
                        this.presetInputList(field);
                    }
                }
                return field;
            case 'NUMBER':
            case 'DECIMAL':
                if(!this._utilityService.isEmptyOrUndefined(field?.value)){
                    field = {...field,value: Array.isArray(field.value) ? field.value : [field.value]};
                }else{
                    field = {...field,value:[],displayKeyValue:[]};
                }
                return field;
            case 'TIME':
                let record: any = {};
                let timeFormat = '';
                const timeFormatRegex = /^\d{2}\:\d{2}\:\d{2}$/;
                if(!this._utilityService.isEmptyOrUndefined(field?.value)){
                    if(Array.isArray(field?.value)){
                        timeFormat = field.value[0].match(timeFormatRegex) ? 'HH:mm:ss' : this._utilityService.timeFormat;
                        record = {...field,displayKeyValue:[],time: moment(field?.value[0] !== ''? field?.value[0]: null,timeFormat),time2:moment(field?.value[1] !== ''? field?.value[1]: null,timeFormat)};
                        record.value[0] = dayjs(field?.value[0],timeFormat).format(this._utilityService.timeFormat);
                        if(field.operator === 'BETWEEN'){
                            record.value[1] = dayjs(field?.value[1],timeFormat).format(this._utilityService.timeFormat);
                        }
                    }else{
                        timeFormat = field.value.match(timeFormatRegex) ? 'HH:mm:ss' : this._utilityService.timeFormat;
                        record = {...field,displayKeyValue:[],time: moment(field?.value !== ''? field?.value: null,timeFormat),time2:moment(null),value:[field.value]};
                        record.value[0] = dayjs(field?.value,timeFormat).format(this._utilityService.timeFormat);
                    }
                }else{
                    const timeData: moment.Moment = null;
                    record = {...field,value:[],time: timeData,time2:timeData};
                }
                return record;
            case 'DATE':
                let recorddate: any = {};
                let format = '';
                const formatRegex = /^\d{4}\-\d{1,2}\-\d{1,2}$/;
                if(this._utilityService.isEmptyOrUndefined(field?.rangeKey)){
                    field.rangeKey = null;
                }
                if(!this._utilityService.isEmptyOrUndefined(field?.value)){
                    if(Array.isArray(field?.value)){
                        format = field.value[0]?.match(formatRegex) ? 'YYYY-MM-DD' : this._utilityService.dateFormat;
                        recorddate = {...field,displayKeyValue:[],date: new FormControl(moment(moment(field?.value[0] !== ''? this._utilityService.formatDateTimeToUserDefined(field.value[0],format,'date'): null,this._utilityService.dateFormat).toDate())),date2: new FormControl(moment(moment(field?.value[1] !== ''? this._utilityService.formatDateTimeToUserDefined(field.value[1],format,'date'): null,this._utilityService.dateFormat).toDate()))};
                        recorddate.value[0] = this._utilityService.formatDateTimeToUserDefined(field.value[0],format,'date');
                        if(field.operator === 'BETWEEN'){
                            recorddate.value[1] = this._utilityService.formatDateTimeToUserDefined(field.value[1],format,'date');
                        }
                    }else{
                        format = field.value.match(formatRegex) ? 'YYYY-MM-DD' : this._utilityService.dateFormat;
                        recorddate = {...field,displayKeyValue:[],date: new FormControl(moment(field?.value !== ''? this._utilityService.formatDateTimeToUserDefined(field.value,format,'date') : null,this._utilityService.dateFormat).toDate()),date2: new FormControl(moment(null)),value:[field.value]};
                        recorddate.value[0] = this._utilityService.formatDateTimeToUserDefined(field.value,format,'date');
                    }
                }else{
                    recorddate = {...field,value:[],date: new FormControl(null),date2: new FormControl(null)};
                }
                recorddate.date.valueChanges.subscribe((data: any)=>{
                    this.filterOptionalValues[index].value[0] = dayjs(data).format(this.dateFormat);
                    this.filterOptionalValues[index].date2.setValue(null);
                    this.filterOptionalValues[index].value[1] = null;
                this.filterOptionalValues[index].displayKeyValue = [data];});
                recorddate.date2.valueChanges.subscribe((data: any)=>{ this.filterOptionalValues[index].value[1] = !this._utilityService.isEmptyOrUndefined(data) ? dayjs(data).format(this.dateFormat) : null;
                this.filterOptionalValues[index].displayKeyValue[1] = data;});
                return  recorddate;
            case 'DATETIME':
                let recorddatetime: any = {};
                if(!this._utilityService.isEmptyOrUndefined(field?.value)){
                    if(Array.isArray(field?.value)){
                        const datetime = moment(moment(field?.value[0] !== ''? this._utilityService.convertBackFromUTC(field.value[0],'YYYY-MM-DD HH:mm:ss','datetime'): null,this._utilityService.dateTimeFormat).toDate());
                        const datetime2 = moment(moment(field?.value[1] !== ''? this._utilityService.convertBackFromUTC(field.value[1],'YYYY-MM-DD HH:mm:ss','datetime') : null,this._utilityService.dateTimeFormat).toDate());
                        recorddatetime = {...field,displayKeyValue:[],datetime: new FormControl(datetime),datetime2: new FormControl(datetime2)};
                        recorddatetime.value[0] = this._utilityService.convertBackFromUTC(field.value[0],'YYYY-MM-DD HH:mm:ss','datetime');
                        if(field.operator === 'BETWEEN'){
                            recorddatetime.value[1] = this._utilityService.convertBackFromUTC(field.value[1],'YYYY-MM-DD HH:mm:ss','datetime') ;
                        }
                    }else{
                        recorddatetime = {...field,displayKeyValue:[],datetime: new FormControl(moment(moment(field?.value !== ''? this._utilityService.convertBackFromUTC(field.value,'YYYY-MM-DD HH:mm:ss','datetime') : null,this._utilityService.dateTimeFormat).toDate())),datetime2: new FormControl(moment(null)),value:[field.value]};
                        recorddatetime.value[0] = this._utilityService.convertBackFromUTC(field.value,'YYYY-MM-DD HH:mm:ss','datetime') ;
                    }
                }else{
                    recorddatetime = {...field,value:[],datetime: new FormControl(null),datetime2: new FormControl(null)};
                }
                recorddatetime
                        .datetime.valueChanges.subscribe((data: any)=>{ recorddatetime.value[0] = dayjs(data).format(this.dateTimeFormat);
                                                                        recorddatetime.datetime2.setValue(null);
                                                                        recorddatetime.value[1] = null;});
                recorddatetime
                    .datetime2.valueChanges.subscribe((data: any)=>{ recorddatetime.value[1] = !this._utilityService.isEmptyOrUndefined(data) ? dayjs(data).format(this.dateTimeFormat) : null;});
                return recorddatetime;
            case 'MULTI_ITEM':
                if(!this._utilityService.isEmptyOrUndefined(field?.value)){
                    const returnValue = {...field,checked:(field?.value?.length === this.getfieldValueAlignedToField( field?.key)?.length -1) ? Array(this.getfieldValueAlignedToField(field?.key)?.length).fill(true) : this.getfieldValueAlignedToField(field.key).map((data: any)=> [...field.value].includes(data[this.getValueKey(field.key)]))};
                    return returnValue
                }else{
                    return {...field,checked:Array(this.getfieldValueAlignedToField( field?.key)?.length).fill(false),value:[],displayKeyValue:[]};
                }
            default:
                return {...field};
        }
    }

    onFocusFieldType(): void{
        this.mockKeys = this.fieldKeys;
    }

    modelChange(event): any{
        this.mockKeys = this.fieldKeys.filter((data: any)=>data.key.toLowerCase().includes(event.toLowerCase()));
    }

    resetRangeFieldValues(field, index): any{
        this.filterOptionalValues[index].value = this.filterOptionalValues[index].value2 = '';
        this.changeDetectorRef.markForCheck();
    }

    setInitialValuesToFields(field,index,action: string = 'update'): void{
        const fieldType = this.getFieldType(field.key);
        this.currentField = this.filterOptionalValues[index];
        switch(fieldType){
            case 'LOOKUP':
                this.pageSize = 1;
                this.filterOptionalValues[index] = {...this.filterOptionalValues[index],valueSubject$:new Subject<string | null>(),displayKeyValue:[],listPreData:[]};
                this.currentField = this.filterOptionalValues[index];
                this.presetInputList(this.filterOptionalValues[index]);
                this.changeDetectorRef.markForCheck();
                break;
            case 'BOOLEAN':
                this.filterOptionalValues[index] = {...this.filterOptionalValues[index],value:true,displayKeyValue:[]};
                this.setDisplayKeyValue(this.filterOptionalValues[index],index);
                this.changeDetectorRef.markForCheck();
                break;
            case 'NUMBER':
            case 'DECIMAL':
                this.filterOptionalValues[index] = {...this.filterOptionalValues[index],value:[],displayKeyValue:[]};
                this.setDisplayKeyValue(this.filterOptionalValues[index],index);
                this.changeDetectorRef.markForCheck();
                break;
            case 'MULTI_ITEM':
                this.filterOptionalValues[index] = {...this.filterOptionalValues[index],checked:Array(this.getfieldValueAlignedToField( this.filterOptionalValues[index]?.key)?.length).fill(false),value:[],displayKeyValue:[]};
                this.changeDetectorRef.markForCheck();
                break;
            case 'TIME':
                const timeData: moment.Moment = null;
                this.filterOptionalValues[index] = {...this.filterOptionalValues[index],value:[],time: timeData,time2:timeData};
                this.changeDetectorRef.markForCheck();
                break;
            case 'DATE':
                this.filterOptionalValues[index] = {...this.filterOptionalValues[index],value:[],date: new FormControl(null),date2: new FormControl(null)};
                this.filterOptionalValues[index]
                    .date.valueChanges.subscribe((data: any)=>{
                                                                this.filterOptionalValues[index].value[0] = dayjs(data).format(this.dateFormat);
                                                                this.filterOptionalValues[index].date2.setValue(null);
                                                                this.filterOptionalValues[index].value[1] = null;});
                this.filterOptionalValues[index]
                    .date2.valueChanges.subscribe((data: any)=>{
                        this.filterOptionalValues[index].value[1] = !this._utilityService.isEmptyOrUndefined(data) ? dayjs(data).format(this.dateFormat) : null;
                    });
                this.changeDetectorRef.markForCheck();
                break;
            case 'DATETIME':
                this.filterOptionalValues[index] = {...this.filterOptionalValues[index],value:[],datetime: new FormControl(null),datetime2: new FormControl(null)};
                this.filterOptionalValues[index]
                    .datetime.valueChanges.subscribe((data: any)=>{ this.filterOptionalValues[index].value[0] = dayjs(data).format(this.dateTimeFormat);
                                                                    this.filterOptionalValues[index].datetime2.setValue(null);
                                                                    this.filterOptionalValues[index].value[1] = null;});
                this.filterOptionalValues[index]
                    .datetime2.valueChanges.subscribe((data: any)=>{ this.filterOptionalValues[index].value[1] = !this._utilityService.isEmptyOrUndefined(data) ? dayjs(data).format(this.dateTimeFormat) : null;});
                this.changeDetectorRef.markForCheck();
                break;
            default:
                this.setDisplayKeyValue(this.filterOptionalValues[index],index,action);
                this.changeDetectorRef.markForCheck();
                break;
        }
    }

    valueChange(field,index): void{
        if(this.fieldKeys.filter((data: any)=>data.value === field.key)?.length > 0 ){
            this.currentField = field;
            const fieldType = this.getFieldType(field.key);
            const operator = this.getOperatorsAlignedToField(field.key)[0]?.displayValue;
            this.filterOptionalValues[index].operator = operator;
            if(this.filterOptionalValues[index]?.key === this.additionalFilters?.key){
                this.filterOptionalValues[index].filterKey = this.additionalFilters;
            }
            let value = '';
            if(this.getFieldType(field.key) === 'DROPDOWN' && !this.getMultiSelectValue(field.key)){
                value = this.getfieldValueAlignedToField(field.key)[0][this.getValueKey(field.key)];
                this.filterOptionalValues[index].value = value;
                this.OnFieldValueChange(this.filterOptionalValues[index],index);
            }else{
                this.filterOptionalValues[index].value = this.filterOptionalValues[index].value2 =  ['TIME','DATE','DATETIME'].includes(fieldType) ? [] : '';
            }
            this.filterOptionalValues[index] = {...this.filterOptionalValues[index],key:field.key};
            this.setInitialValuesToFields(field,index);
            this.OnOperatorChange(field,index);
            this.changeDetectorRef.markForCheck();
        }
    }

    getCategoryUids(categoryUID): string{
        return categoryUID && Array.isArray(categoryUID) ? categoryUID.join(',') : categoryUID ?? '';
    };

    setListValue(field,term): any{
        if([null,undefined].includes(term)){
            this.lookupLoading = false;
            this.changeDetectorRef.markForCheck();
            return of(null);
        }

        const fieldObject = this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field.key);
        const fieldValueURL = fieldObject?.data.url;
        const querryKey = fieldObject?.data.searchParam;
        const dataUrl = `${this._dataCollectorService.baseurl()}${fieldValueURL}`;
        this.pageSize = 1;
        let paramObj = {
            page:this.pageSize,
            [querryKey]:term || ''
        };
        this.currentField = field;
        this.currentSearchTerm = term;
        if(this.module === 'JOB' && fieldObject?.fieldDataKey === 'status_uid' && fieldObject?.displayName === 'Job Status'){
            const categoryUID = this.filterOptionalValues?.find((data: any)=> data?.key === 'job_category_uid')?.value;
            paramObj = {
                'page':this.pageSize,
                'count': 100,
                'filter.category_uid': this.getCategoryUids(categoryUID),
            };
        }
        if(this.module === 'PROJECT' && fieldObject?.fieldDataKey === 'project_current_status.status_uid' && fieldObject?.displayName === 'Project Status'){
            const categoryUID = this.filterOptionalValues?.find((data: any)=> data?.key === 'project_category_uid')?.value;
            paramObj = {
                'page':this.pageSize,
                'count': 100,
                'filter.category_uid': this.getCategoryUids(categoryUID),
            };
        }
        if((!this._utilityService.isEmptyOrUndefined(field?.filterKey?.filter) || field?.filterKey?.filter && Object.keys(field?.filterKey?.filter)?.length > 0)){
            paramObj = {
                ...paramObj,
                ...field?.filterKey?.filter
            }
        }else if(!this._utilityService.isEmptyOrUndefined(this.additionalFilters) && Object.keys(this.additionalFilters)?.length > 0 && this.additionalFilters?.key === field?.key && Object.keys(this.additionalFilters?.filter)?.length > 0){
            paramObj = {
                ...paramObj,
                ...this.additionalFilters?.filter
            }
        }
        return this._dataCollectorService.getData(dataUrl,paramObj)
        .pipe(map((response: any)=>{
            this.totalPages = response?.total_pages;
            const responseData = _.cloneDeep(response.data);
            if(this.module === 'JOB' && fieldObject?.fieldDataKey === 'status_uid' && fieldObject?.displayName === 'Job Status'){
                const listData = [];
                responseData.forEach((element: any)=>{
                    const status = element?.job_statuses.filter((jobstatus: any)=>{
                        if(this.currentSearchTerm && this.currentSearchTerm.length >= 0){
                            return jobstatus?.status_name.toLowerCase().includes(this.currentSearchTerm.toLowerCase());
                        }else{
                            return jobstatus;
                        }
                    }).map((data: any)=>({...data,category_uid: element?.category_uid,category_name: element?.category_name}));
                    listData.push(status);
                });
                this.currentPreloadedValue = [...this.currentPreloadedValue,...listData.flat()];
                this.currentSearchTerm = '';
                return listData.flat();
            }else if(this.module === 'PROJECT' && fieldObject?.fieldDataKey === 'project_current_status.status_uid' && fieldObject?.displayName === 'Project Status'){
                const listData = [];
                responseData.forEach((element: any)=>{
                    const status = element?.project_statuses?.filter((projectstatus: any)=>{
                        if(this.currentSearchTerm && this.currentSearchTerm.length >= 0){
                            return projectstatus?.project_status_name.toLowerCase().includes(this.currentSearchTerm.toLowerCase());
                        }else{
                            return projectstatus;
                        }
                    }).map((data: any)=>({...data,category_uid: element?.category_uid,category_name: element?.category_name}));
                    listData.push(status);
                });
                field.listPreData = listData.flat();
                this.currentSearchTerm = '';
            }else{
                this.currentPreloadedValue = [...this.currentPreloadedValue,...this.constructLookupList(fieldObject,responseData)];
                return this.constructLookupList(fieldObject,responseData);
            }
        }));

    }

    OnOperatorChange(field: any,index: number): void{
        if(['IS_EMPTY','IS_NOT_EMPTY','BETWEEN'].includes(this.filterOptionalValues[index]?.operator)){
            switch (this.getFieldType(this.filterOptionalValues[index].key)) {
                case 'TIME':
                    this.filterOptionalValues[index].time = this.filterOptionalValues[index].time2 = null;
                    this.changeDetectorRef.markForCheck();
                    break;
                case 'DATE':
                    this.filterOptionalValues[index].date.setValue(moment(null));
                    this.filterOptionalValues[index].date2.setValue(moment(null));
                    this.changeDetectorRef.markForCheck();
                break;
                case 'DATETIME':
                    this.filterOptionalValues[index].datetime.setValue(moment(null));
                    this.filterOptionalValues[index].datetime2.setValue(moment(null));
                    this.changeDetectorRef.markForCheck();
                break;
                case 'BOOLEAN':
                case 'CHECKBOX':
                    this.filterOptionalValues[index].value = [];
                    this.filterOptionalValues[index].checked = [];
                    this.changeDetectorRef.markForCheck();
                break;
                default:
                    this.filterOptionalValues[index].value = [];
                    this.changeDetectorRef.markForCheck();
                break;
            }
            if(this.filterOptionalValues[index].value){
                this.filterOptionalValues[index].value = Array.isArray(this.filterOptionalValues[index].value) ? [] : '';
                this.changeDetectorRef.markForCheck();
            }else{
                this.filterOptionalValues[index].value = [];
                this.changeDetectorRef.markForCheck();
            }
        }
        this.filterOptionalValues[index] = {...this.filterOptionalValues[index],displayKeyValue:['IS_EMPTY','IS_NOT_EMPTY'].includes(this.filterOptionalValues[index]?.operator) ? [] : this.filterOptionalValues[index]?.displayKeyValue};
        if(!this._utilityService.isEmptyOrUndefined(this.filterOptionalValues[index].operator)){
            const rangeKey = this.filterOptionalValues[index].operator === 'BETWEEN' && this.getFieldType(this.filterOptionalValues[index].key) === 'DATE' ? this.rangeFilter['BETWEEN'][0]?.rangeKey : this.rangeFilter['SINGLE'][0]?.rangeKey;
            this.filterOptionalValues[index].rangeKey = rangeKey
            if(this.getFieldType(this.filterOptionalValues[index].key) === 'DATE' && !this._utilityService.isEmptyOrUndefined(rangeKey)){
                this.OnRangeChange(this.filterOptionalValues[index],index);
            }
        }else{
            this.filterOptionalValues[index].rangeKey = null;
            this.resetRangeFieldValues(this.filterOptionalValues[index],index);
        }
        
        if(this.getFieldType(this.filterOptionalValues[index].key) === 'LOOKUP'){
            this.triggerLookupPopulateValue(index);
        }
        this.changeDetectorRef.markForCheck();
    }

    OnLookUPFieldValueChange(event,field,index): void{
        this.filterOptionalValues[index].displayKeyValue =  [...new Set([...event.map((data: any)=>{
            if(this.getFieldType(field.key) ==='DROPDOWN'){
                return data[this.getDisplayKey(field.key)];
            }else{
                if(this.getDataKeyOfLookUp(field) === 'status_uid' && this.module === 'JOB' && this.getDisplayName(field.key) === 'Job Status'){
                    return data?.status_name;
                }else if(this.getDataKeyOfLookUp(field) === 'status_uid' && this.module === 'PROJECT' && this.getDisplayName(field.key) === 'Project Status'){
                    return data?.project_status_name;
                }else{
                    return data?.bindLabel ? data?.bindLabel : data?.key;
                }
            }
        })])];
        this.changeDetectorRef.markForCheck();
    }

    onLookupFocused(field): void{
        this.currentSearchTerm = '';
        this.pageSize = 1;
        const fieldObject = this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field.key);
        const fieldValueURL = fieldObject?.data.url;
        const dataUrl = `${this._dataCollectorService.baseurl()}${fieldValueURL}`;
        let categoryUID = '';
        if(this.module === 'JOB'){
            categoryUID = this.filterOptionalValues?.find((data: any)=> data?.key === 'job_category_uid')?.value;
        }else if(this.module === 'PROJECT'){
            categoryUID = this.filterOptionalValues?.find((data: any)=> data?.key === 'project_category_uid')?.value;
        }
        const paramObj = {
            'page':this.pageSize,
            'count': 100,
            'filter.category_uid': this.getCategoryUids(categoryUID),
        };
        this._dataCollectorService.getData(dataUrl,paramObj)
        .subscribe((response: any)=>{
            this.totalPages = response?.total_pages;
            const responseData = _.cloneDeep(response.data);
            const listData = [];
            if(this.module === 'JOB'){
                responseData.forEach((element: any)=>{
                    const status = element?.job_statuses?.filter((jobstatus: any)=>{
                        if(this.currentSearchTerm && this.currentSearchTerm.length >= 0){
                            return jobstatus?.status_name.toLowerCase().includes(this.currentSearchTerm.toLowerCase());
                        }else{
                            return jobstatus;
                        }
                    }).map((data: any)=>({...data,category_uid: element?.category_uid,category_name: element?.category_name}));
                    listData.push(status);
                });
            }else if(this.module === 'PROJECT'){
                responseData.forEach((element: any)=>{
                    const status = element?.project_statuses?.filter((projectstatus: any)=>{
                        if(this.currentSearchTerm && this.currentSearchTerm.length >= 0){
                            return projectstatus?.project_status_name.toLowerCase().includes(this.currentSearchTerm.toLowerCase());
                        }else{
                            return projectstatus;
                        }
                    }).map((data: any)=>({...data,category_uid: element?.category_uid,category_name: element?.category_name}));
                    listData.push(status);
                });
            }
            this.currentPreloadedValue = [...listData.flat()];
            this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field.key).data.listValue$ = of(this.currentPreloadedValue);
            this.changeDetectorRef.markForCheck();
        });
    }

    getDisplayKeyValue(field): any{
        let returnVaue: any = '';
        switch (this.getFieldType(field.key)) {
            case 'TIME':
                let displayKeyValueTime: any = [];
                if(!this._utilityService.isEmptyOrUndefined(field?.value)){
                    if(Array.isArray(field?.value)){
                        if(!this._utilityService.isEmptyOrUndefined(field?.value[0]) && moment(field?.value[0],this._utilityService.timeFormat).isValid()){
                            displayKeyValueTime[0] = field?.value[0];
                        }else{
                            displayKeyValueTime[0] = null;
                        }
                        if(field.operator === 'BETWEEN' && field.time2 && !this._utilityService.isEmptyOrUndefined(field?.value[1]) && moment(field?.value[1],this._utilityService.timeFormat).isValid()){
                            displayKeyValueTime[1] = field?.value[1];
                        }
                    }else{
                        displayKeyValueTime = moment(field?.value).isValid() ? [field?.value] : [];
                    }
                }
                returnVaue =  displayKeyValueTime;
                break;
            case 'DATE':
                let displayKeyValueDate: any = [];
                if(!this._utilityService.isEmptyOrUndefined(field?.value)){
                    if(this._utilityService.isEmptyOrUndefined(field?.rangeKey) || ['CUSTOM_DATE','CUSTOM_RANGE'].includes(field.rangeKey)){
                        if(Array.isArray(field?.value)){
                            if(!this._utilityService.isEmptyOrUndefined(field?.value[0]) && moment(field?.value[0],this._utilityService.dateFormat).isValid()){
                                displayKeyValueDate[0] = dayjs(field.value[0],'YYYY-MM-DD').format(this._utilityService.dateFormat) !== 'Invalid Date' ?
                                                        dayjs(field.value[0],'YYYY-MM-DD').format(this._utilityService.dateFormat) :
                                                        dayjs(field.value[0],this._utilityService.dateFormat).format(this._utilityService.dateFormat);
                            }else{
                                displayKeyValueDate[0] = null;
                            }
                            if(field.operator === 'BETWEEN' && !this._utilityService.isEmptyOrUndefined(field?.value[1]) && moment(field?.value[1],this._utilityService.dateFormat).isValid()){
                                displayKeyValueDate[1] = dayjs(field.value[1],'YYYY-MM-DD').format(this._utilityService.dateFormat) !== 'Invalid Date' ?
                                dayjs(field.value[1],'YYYY-MM-DD').format(this._utilityService.dateFormat) :
                                dayjs(field.value[1],this._utilityService.dateFormat).format(this._utilityService.dateFormat);
                            }
                        }else{
                            displayKeyValueDate[0] = dayjs(field.value,'YYYY-MM-DD').format(this._utilityService.dateFormat) !== 'Invalid Date' ?
                                                    dayjs(field.value,'YYYY-MM-DD').format(this._utilityService.dateFormat) :
                                                    dayjs(field.value,this._utilityService.dateFormat).format(this._utilityService.dateFormat);
                        }
                    }else{
                        const key = this._utilityService.advanceFilterDateRange.find((data: any)=> data?.rangeKey === field?.rangeKey)?.key;
                        const value = this._utilityService.advanceFilterDateRange.find((data: any)=> data?.rangeKey === field?.rangeKey)?.value;
                        const data = field?.operator !== 'BETWEEN' ? [dayjs(value[0],this._utilityService.dateFormat).format(this._utilityService.dateFormat)] : [dayjs(value[0],this._utilityService.dateFormat).format(this._utilityService.dateFormat),dayjs(value[1],this._utilityService.dateFormat).format(this._utilityService.dateFormat)];
                        displayKeyValueDate = key && field?.operator !== 'BETWEEN' ? [`${key} (${data[0]})`] :  [`${key} (${data[0]} - ${data[1]})`];
                    }
                }
                returnVaue = displayKeyValueDate;
                break;
            case 'DATETIME':
                const displayKeyValueDateTime: any = [];
                if(!this._utilityService.isEmptyOrUndefined(field?.value)){
                    if(Array.isArray(field?.value)){
                        if(!this._utilityService.isEmptyOrUndefined(field?.value[0]) && moment(field?.value[0]).isValid()){
                            displayKeyValueDateTime[0] = dayjs(field.value[0],'YYYY-MM-DD HH:mm:ss').format(this._utilityService.dateFormat) !== 'Invalid Date' ?
                                                        dayjs(field.value[0],'YYYY-MM-DD HH:mm:ss').format(this._utilityService.dateFormat) :
                                                        dayjs(field.value[0],this._utilityService.dateTimeFormat).format(this._utilityService.dateTimeFormat);
                        }else{
                            displayKeyValueDateTime[0] = null;
                        }
                        if(field.operator === 'BETWEEN' && !this._utilityService.isEmptyOrUndefined(field?.value[1])&& moment(field?.value[1]).isValid()){
                            displayKeyValueDateTime[1] = dayjs(field.value[1],'YYYY-MM-DD HH:mm:ss').format(this._utilityService.dateFormat) !== 'Invalid Date' ?
                                                        dayjs(field.value[1],'YYYY-MM-DD HH:mm:ss').format(this._utilityService.dateFormat) :
                                                        dayjs(field.value[1],this._utilityService.dateTimeFormat).format(this._utilityService.dateTimeFormat);
                        }
                    }else{
                        displayKeyValueDateTime[0] = dayjs(field.value,'YYYY-MM-DD HH:mm:ss').format(this._utilityService.dateFormat) !== 'Invalid Date' ?
                                                    dayjs(field.value,'YYYY-MM-DD HH:mm:ss').format(this._utilityService.dateFormat) :
                                                    dayjs(field.value,this._utilityService.dateTimeFormat).format(this._utilityService.dateTimeFormat);
                    }
                }
                returnVaue = displayKeyValueDateTime;
                break;
            case 'MULTI_ITEM':
                let displayKeyValueMultiItem: any = [];
                if(!this._utilityService.isEmptyOrUndefined(field?.value)){
                    if(Array.isArray(field?.value)){
                        displayKeyValueMultiItem = field?.value?.filter((data: any)=> data !== 'Select All');
                    }else{
                        displayKeyValueMultiItem = field?.value;
                    }
                }
                returnVaue = displayKeyValueMultiItem;
                break;
            default :
                returnVaue = field?.displayKeyValue;
                break;
        }

        if(Array.isArray(returnVaue)){
            returnVaue = returnVaue?.join(', ');
        }

        return returnVaue;
    }

    setDisplayKeyValue(field,index,action: string = 'update'): void{
        if(!['TIME','DATE','DATETIME'].includes(this.getFieldType(field.key))){
            if(this.filterOptionalValues[index].value){
                if(field.operator === 'BETWEEN'){
                    this.filterOptionalValues[index].displayKeyValue = [...new Set([field.value[0],field.value[1]])];
                }else if(this.getMultiSelectValue(this.filterOptionalValues[index].key)){
                    this.filterOptionalValues[index].displayKeyValue = [...new Set([...this.filterOptionalValues[index].displayKeyValue,field.value])];
                }else if(this.getFieldType(this.filterOptionalValues[index].key) !== 'DROPDOWN'){
                    this.filterOptionalValues[index].displayKeyValue =  [...new Set([Array.isArray(field.value) ? field.value.filter((data: any)=> ![null,undefined,''].includes(data))[0]:
                    field.value])];
                }else if(this.getFieldType(this.filterOptionalValues[index].key) === 'DROPDOWN'){
                    const fieldValueArray = this.getfieldValueAlignedToField(field.key);
                    this.filterOptionalValues[index].displayKeyValue = [fieldValueArray?.find((data: any)=>data[this.getValueKey(field.key)] === field.value)[this.getDisplayKey(field.key)]];
                }
                this.changeDetectorRef.markForCheck();

            }else if(this.getFieldType(this.filterOptionalValues[index].key) === 'DROPDOWN' && !this.getMultiSelectValue(this.filterOptionalValues[index].key) && this._utilityService.isEmptyOrUndefined(this.filterOptionalValues[index].value) && action !== 'removeValue'){
                const value = this.getfieldValueAlignedToField(this.filterOptionalValues[index].key)[0][this.getValueKey(this.filterOptionalValues[index].key)];
                this.filterOptionalValues[index].value = value;
                this.OnFieldValueChange(this.filterOptionalValues[index],index);
                this.changeDetectorRef.markForCheck();
            }
        }
    }

    OnFieldValueChange(field,index): void{
        const fieldValueArray = this.getfieldValueAlignedToField(field.key);
        if(fieldValueArray?.find((data: any)=>data[this.getValueKey(field.key)] === field.value)){
            this.filterOptionalValues[index].displayKeyValue = [fieldValueArray?.find((data: any)=>data[this.getValueKey(field.key)] === field.value)[this.getDisplayKey(field.key)]];
        }
        this.changeDetectorRef.markForCheck();
    }

    setInputValue(field,index,type,valueIndex: any): void{
        switch(type){
            case 'TIME':
                if(valueIndex === 0){
                    this.filterOptionalValues[index].value[0] = dayjs(field.time).format(this._utilityService.timeFormat);
                }
                if(valueIndex === 1){
                    this.filterOptionalValues[index].value[1] = dayjs(field.time2).format(this._utilityService.timeFormat);
                }
                this.changeDetectorRef.markForCheck();
                break;
        }
    }

    resetFilterValue(): void{
        this.filterOptionalValues = [];
        const url = window.location.href;
        if(!url.includes('reports/')){
            this.localStorageService.setLocalStorage(`${this.module.toLowerCase()}_filter_value`,'all');
            this.localStorageService.setLocalStorage(`${this.module.toLowerCase()}_filter_rules`,this.filterOptionalValues);
        }
        if(!this._utilityService.isEmptyOrUndefined(this.zuperDrawerService.getComponent('rightDrawer'))){
            this.toggleDrawer('rightDrawer','apply');
        }else{
            this.setFilterComponentEmitValue('apply');
        }
        this.changeDetectorRef.markForCheck();
    }

    constructLookupList(fieldObject, data): any{
        return data.map((key: any)=>({...key,displayValue:this.constructTemplateValue(fieldObject.fieldLabelKey,key),bindLabel:this.constructTemplateValue(fieldObject.data?.bindLabel,key)}));
    }

    get getAppliedFilterCount(): number | string{
        let filterRules = this.localStorageService.getLocalStorage(`${this.module.toLowerCase()}_filter_rules`);
        filterRules = filterRules === '[]' ? this.advanceFilterService.getValidFilters(JSON.parse(filterRules)) : this.advanceFilterService.getValidFilters(filterRules);
        if( this.module === 'TIMESHEET'){
            return filterRules.find((rules: any)=> rules.key === 'checked_time') ? filterRules?.length-1 : filterRules?.length;
        }
        return filterRules === '[]' ? JSON.parse(filterRules)?.length : filterRules?.length;
    }

    get fieldValues(): Array<string>{
        return this.filterOptionalValues.map((data: any)=>data.key);
    }

    onFormSubmit(index,field,form): void{
        if(['IS_EMPTY','IS_NOT_EMPTY'].includes(field.operator)){
            this.filterOptionalValues[index].value = this.filterOptionalValues[index].displayKeyValue = [];
        }
        switch(this.getFieldType(field.key)){
            case 'NUMBER':
            case 'DECIMAL':
                this.filterOptionalValues[index] = {...this.filterOptionalValues[index],value: Array.isArray(this.filterOptionalValues[index].value) ? this.filterOptionalValues[index].value : [this.filterOptionalValues[index].value]};
                this.excecuteOnValidField(index);
                this.changeDetectorRef.markForCheck();
                break;
            case 'MULTI_ITEM':
                let selectValue = [];
                const dataKey = this.filterOptionalValues[index]?.key;
                this.filterOptionalValues[index]?.checked.forEach((data: any,i)=>{
                    const fieldDataValues: any =  this.getfieldValueAlignedToField(dataKey);
                    if(data && fieldDataValues && fieldDataValues[i]){
                        selectValue = [...selectValue,fieldDataValues[i][this.getValueKey(dataKey)].trim()];
                    }
                });
                this.filterOptionalValues[index] = {...this.filterOptionalValues[index],value:selectValue};
                this.filterOptionalValues[index].displayKeyValue = [...this.filterOptionalValues[index]?.value];
                this.excecuteOnValidField(index);
                this.changeDetectorRef.markForCheck();
                break;
            case 'TAGS':
                this.tagsSubmitted = true;
                if(form.valid){
                    this.excecuteOnValidField(index);
                }
                break;
            default:
                if(form.valid){
                    this.excecuteOnValidField(index);
                }
                break;
        }
    }

    excecuteOnValidField(index): void{
        this.filterOptionalValues[index].showForm = !this.filterOptionalValues[index].showForm;
        this.setFilterComponentEmitValue('apply');
        this.showNewForm=false;
        this.tagsSubmitted = false;
        this.changeDetectorRef.markForCheck();
    }

    saveFilterValueChange(): void{
        this.setFilterComponentEmitValue('apply');
    }

    getPlaceHolder(field,place): string{
        switch(place){
            case 'to':
                switch(this.getFieldType(field.key)){
                    case 'DATE':
                        return field.operator === 'BETWEEN' ? 'text.choose_to_date' : 'text.choose_date';
                        break;
                    case 'TIME':
                        return field.operator === 'BETWEEN' ? 'generatefilter.timefield.totime.placeholder' : 'generatefilter.timefield.placeholder';
                        break;
                    case 'DATETIME':
                        return field.operator === 'BETWEEN' ? 'generatefilter.datetimefield.to.placeholder' : 'generatefilter.datetimefield.placeholder';
                        break;
                    }
                break;
            case 'from':
                switch(this.getFieldType(field.key)){
                    case 'DATE':
                        return field.operator === 'BETWEEN' ? 'text.choose_from_date' : 'text.choose_date';
                        break;
                    case 'TIME':
                        return field.operator === 'BETWEEN' ? 'generatefilter.timefield.fromtime.placeholder' : 'generatefilter.timefield.placeholder';
                        break;
                    case 'DATETIME':
                        return field.operator === 'BETWEEN' ? 'generatefilter.datetimefield.from.placeholder' : 'generatefilter.datetimefield.placeholder';
                        break;
                }
                break;
        }
    }

    getMeridian(): boolean{
        return this.timeFormat === 12 ? true : false;
    }

    isNumberFieldValueArray(value: any): boolean{
        return Array.isArray(value);
    }

    getDataKeyOfLookUp(field): any{
        return this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field.key)?.data?.dataKey;
    }

    get maximumDecimalValueErrorMessage(): string{
        return `${this._utilityService.getLocaleValue('generateFilter.field_value.decimal.message')} : ${this.localStorageService.getLocalStorage('company_configuration_data')?.general?.decimal_roundoff || 2}`;
    }

    get stepValue(): number{
        const defaultDecimalLimit = this.localStorageService.getLocalStorage('company_configuration_data')?.general?.decimal_roundoff || 2;
        return 1/ 10**defaultDecimalLimit;
    }

    showClearFilter(): boolean{
        const filter = this.localStorageService.getLocalStorage(`${this.module?.toLowerCase()}_filter_rules`);
        if( filter && Array.isArray(filter) && filter?.length){
            return filter?.filter((data: any)=> data?.key !== 'keyword')?.length > 0;
        }else{
            return false;
        }
    }

    addKeywordFromInput(event: MatChipInputEvent, index): void {
        if (event.value) {
          this.filterOptionalValues[index].value = `${!this._utilityService.isEmptyOrUndefined(this.filterOptionalValues[index].value) ? this.filterOptionalValues[index].value + ',' : ''}${event.value}`;
          this.setDisplayKeyValue(this.filterOptionalValues[index],index);
          event.chipInput.clear();
          this.changeDetectorRef.markForCheck();
        }
      }

    remove(fieldIndex,valueIndex): void {
        const valueArray = this.filterOptionalValues[fieldIndex].value.split(',');
        if (valueIndex >= 0) {
            valueArray.splice(valueIndex, 1);
            this.filterOptionalValues[fieldIndex].value = valueArray.join(',');
        }
      }

    getTags(value): any{
        if(value && Array.isArray(value)){
            return value;
        }else if(value && !Array.isArray(value)){
            return value.split(',');
        }else{
            return [];
        }
    }

    onLookupScrollEnd(event,index): any{
        if(this.pageSize < this.totalPages){
            this.pageSize += 1;
            const fieldObject: any = this.filterFieldOptions.find((data: any)=>data.fieldDataKey === this.currentField.key);
            const fieldValueURL = fieldObject?.data.url;
            const querryKey = fieldObject?.data.searchParam;
            const dataUrl = `${this._dataCollectorService.baseurl()}${fieldValueURL}`;
            let paramObj: any = {
                page:this.pageSize,
                [querryKey]:this.currentSearchTerm || ''
            };
            if(this.module === 'JOB' && fieldObject?.fieldDataKey === 'status_uid' && fieldObject?.displayName === 'Job Status'){
                const categoryUID = this.filterOptionalValues?.find((data: any)=> data?.key === 'job_category_uid')?.value;
                paramObj = {
                    'page':this.pageSize,
                    'count': 100,
                    'filter.category_uid': this.getCategoryUids(categoryUID),
                };
            }
            if(this.module === 'PROJECT' && fieldObject?.fieldDataKey === 'project_current_status.status_uid' && fieldObject?.displayName === 'Project Status'){
                const categoryUID = this.filterOptionalValues?.find((data: any)=> data?.key === 'project_category_uid')?.value;
                paramObj = {
                    'page':this.pageSize,
                    'count': 100,
                    'filter.category_uid': this.getCategoryUids(categoryUID),
                };
            }
            const filterKey = this.filterOptionalValues.filter((data: any)=>data.key === this.currentField.key)[0]?.filterKey?.filter;
            if((!this._utilityService.isEmptyOrUndefined(filterKey) || filterKey && Object.keys(filterKey)?.length > 0)){
                paramObj = {
                    ...paramObj,
                    ...filterKey
                }
            }else if(!this._utilityService.isEmptyOrUndefined(this.additionalFilters) && Object.keys(this.additionalFilters)?.length > 0 && this.additionalFilters?.key === this.currentField?.key && Object.keys(this.additionalFilters?.filter)?.length > 0){
                paramObj = {
                    ...paramObj,
                    ...this.additionalFilters?.filter
                }
            }
            this.lookupLoading = true;
            this._dataCollectorService.getData(dataUrl,paramObj)
            .subscribe((response: any)=>{
                this.totalPages = response?.total_pages;
                const responseData = _.cloneDeep(response.data);
                if(this.module === 'JOB' && fieldObject?.fieldDataKey === 'status_uid' && fieldObject?.displayName === 'Job Status'){

                    const listData = [];
                    responseData.forEach((element: any)=>{
                        const status = element?.job_statuses?.filter((jobstatus: any)=>{
                            if(this.currentSearchTerm && this.currentSearchTerm.length >= 0){
                                return jobstatus?.status_name.toLowerCase().includes(this.currentSearchTerm.toLowerCase());
                            }else{
                                return jobstatus;
                            }
                        }).map((data: any)=>({...data,category_uid: element?.category_uid,category_name: element?.category_name}));
                        listData.push(status);
                    });
                    this.currentPreloadedValue = [...this.currentPreloadedValue,...listData.flat()];
                    this.currentSearchTerm = '';
                    return listData.flat();
                }else if(this.module === 'PROJECT' && fieldObject?.fieldDataKey === 'project_current_status.status_uid' && fieldObject?.displayName === 'Project Status'){
                    const listData = [];
                    responseData.forEach((element: any)=>{
                        const status = element?.project_statuses?.filter((projectstatus: any)=>{
                            if(this.currentSearchTerm && this.currentSearchTerm.length >= 0){
                                return projectstatus?.project_status_name.toLowerCase().includes(this.currentSearchTerm.toLowerCase());
                            }else{
                                return projectstatus;
                            }
                        }).map((data: any)=>({...data,category_uid: element?.category_uid,category_name: element?.category_name}));
                        listData.push(status);
                    });
                    this.currentPreloadedValue = [...this.currentPreloadedValue,...listData.flat()];
                    this.currentSearchTerm = '';
                    return listData.flat();
                }else{
                    this.currentPreloadedValue = [...this.currentPreloadedValue,...this.constructLookupList(fieldObject,response.data)];
                }
                this.filterFieldOptions.find((data: any)=>data.fieldDataKey === this.currentField.key).data.listValue$ = of(this.currentPreloadedValue);
                this.filterOptionalValues[index].listPreData = this.currentPreloadedValue;
                this.loadLookupValues(this.filterOptionalValues[index]);
                this.changeDetectorRef.markForCheck();
                this.lookupLoading = false;
            });
        }
    }

    resetCurrentFieldValues(field,index): any{
        this.pageSize = 1;
        this.currentSearchTerm = '';
        this.currentPreloadedValue = [];
        this.totalPages = 0;
        this.currentField = this.filterOptionalValues[index];
        const optionIndex: any = this.filterFieldOptions.findIndex(
            (data: any) => data.fieldDataKey === field.key
        );
        this.filterFieldOptions[optionIndex].data.listValue$ = of([]);
        this.currentField.listPreData = [];
        if(this.currentField?.key){
            this.presetInputList(this.currentField);
        }
    }

    removeValuesFromField(index: any): void{
        this.filterOptionalValues[index] = {...this.filterOptionalValues[index],
                                            value: '',
                                            value2: '',
                                            displayKeyValue:[]
        };
        if(['DATETIME','TIME','NUMBER','DECIMAL'].includes(this.getFieldType(this.filterOptionalValues[index].key))){
            this.filterOptionalValues[index].value = [];
            this.changeDetectorRef.markForCheck();
        }else if(this.getFieldType(this.filterOptionalValues[index].key) === 'DATE'){
            this.filterOptionalValues[index].rangeKey = null;
            this.filterOptionalValues[index].value = '';
            this.changeDetectorRef.markForCheck();
        }else if(['MULTI_ITME'].includes(this.getFieldType(this.filterOptionalValues[index].key))){
            this.filterOptionalValues[index] = {...this.filterOptionalValues[index],checked:Array(this.getfieldValueAlignedToField( this.filterOptionalValues[index]?.key)?.length).fill(false),value:[]};
            this.changeDetectorRef.markForCheck();
        }
        this.setInitialValuesToFields(this.filterOptionalValues[index],index,'removeValue');
        this.changeDetectorRef.detectChanges();
    }

    removeOperatorFromField(index: any): void{
        this.filterOptionalValues[index] = {...this.filterOptionalValues[index],
            operator: ''
            };
        this.OnOperatorChange(this.filterOptionalValues[index],index);
        this.removeValuesFromField(index);
        this.changeDetectorRef.detectChanges();
    }

    drop(event: any): void{
        moveItemInArray(this.filterOptionalValues, event.previousIndex, event.currentIndex);
        this.setFilterComponentEmitValue('apply');
    }

    getAddNewTitle(): any{
        return `${this.translateService.instant('text.add.new').toLowerCase()} ${this.module.replace('_',' ').toLowerCase()} ${this.translateService.instant('text.filters').toLowerCase()}`;
    }

    isFormInvalid(form,field): any{
        if(form?.invalid){
            return true;
        }else if(!this._utilityService.isEmptyOrUndefined(field?.value) && this._utilityService.isEmptyOrUndefined(field?.operator)){
            return true;
        }
        else if(this.getFieldType(field?.key) === 'DATE'){
            if(field.operator === 'BETWEEN' && field?.value?.length !== 0 && (!moment(field?.value[0],this.dateFormat).isValid() || !moment(field?.value[1],this.dateFormat).isValid())){
                return true;
            }
        }else if(this.getFieldType(field?.key) === 'DATETIME'){
            if(field.operator === 'BETWEEN' && field?.value?.length !== 0 && (!moment(field?.value[0],this.dateTimeFormat).isValid() || !moment(field?.value[1],this.dateTimeFormat).isValid())){
                return true;
            }
        }else if(['BOOLEAN','MULTI_ITEM'].includes(this.getFieldType(field?.key)) && field?.checked?.filter((data: any)=> data === true)?.length > 0 && this._utilityService.isEmptyOrUndefined(field?.operator)){
            return true;
        }else if(this._utilityService.isEmptyOrUndefined(field?.key)){
            return true;
        }else if(field?.operator === 'BETWEEN' && (this._utilityService.isEmptyOrUndefined(field?.value[0]) && !this._utilityService.isEmptyOrUndefined(field?.value[1]) || !this._utilityService.isEmptyOrUndefined(field?.value[0]) && this._utilityService.isEmptyOrUndefined(field?.value[1]))){
            return true;
        }else{
            return false;
        }
        return false;
    }

    isMultiItemValid(field): any{

        if(['BOOLEAN','MULTI_ITEM'].includes(this.getFieldType(field?.key)) && field?.checked?.filter((data: any)=> data === true)?.length === 0){
            return true;
        }
    }

    get isFormOpen(): boolean{
        return this.filterOptionalValues.findIndex((data: any)=> data?.showForm === true) !== -1 || this.showNewForm === true;
    }

    setMultiValue(event, field, fieldIndex): void {
        const index: any = this.filterFieldOptions.findIndex(
            (data: any) => data.fieldDataKey === field.key
        );
        let option = this.filterFieldOptions[index]?.fieldOptions?.map(
            (data: any) => ({
                ...data,
                checked:
                    event[this.getValueKey(field?.key)] === 'Select All' &&
                        event['checked'] === true
                        ? true
                        : event[this.getValueKey(field?.key)] === 'Select All' &&
                            event['checked'] === false
                            ? false
                            : data?.checked,
            })
        );
        const currentChecked = option?.filter((data: any) => data?.checked);
        if (currentChecked?.length < option?.length) {
            option = option?.map((data: any) => {
                if (data[this.getValueKey(field?.key)] === 'Select All') {
                    data.checked = false;
                }
                return data;
            });
        }
        if (currentChecked?.filter((data: any) => data[this.getValueKey(field?.key)] !== 'Select All')?.length === option?.length - 1) {
            option = option?.map((data: any) => {
                if (data[this.getValueKey(field?.key)] === 'Select All') {
                    data.checked = true;
                }
                return data;
            });
        }
        if (currentChecked?.length === 1 && currentChecked[0][this.getValueKey(field?.key)] === 'Select All') {
            option = option?.map((data: any) => ({ ...data, checked: false }));
        }
        this.filterFieldOptions[index].fieldOptions = option;
        this.filterOptionalValues[fieldIndex].checked = option.map((data: any) => data?.checked);
        this.filterOptionalValues[fieldIndex].value = option
            .map((data: any) => {
                if (data?.checked) {
                    return data[this.getValueKey(field?.key)];
                }
            })
            .filter(
                (val: any) => !this._utilityService.isEmptyOrUndefined(val)
            );
    }

    onClearAllMultiItem(field,index): void{
        const filterOptionIndex = this.filterFieldOptions?.findIndex((data: any)=> data?.fieldDataKey === field.key);
        this.filterFieldOptions[filterOptionIndex].fieldOptions = this.filterFieldOptions[filterOptionIndex].fieldOptions?.map((data: any)=> ({...data, checked: false}));
        const options = this.filterFieldOptions[filterOptionIndex].fieldOptions;
        this.filterOptionalValues[index] = {
            ...this.filterOptionalValues[index],
            checked: options.map((data: any) => data?.checked),
            value: options
                .map((data: any) => {
                    if (data?.checked) {
                        return data[this.getValueKey(field?.key)];
                    }
                })
                .filter(
                    (val: any) => !this._utilityService.isEmptyOrUndefined(val)
                ),
        };
        this.changeDetectorRef.markForCheck();
    }

    clearItem(index: any): void{
        const value = this.filterOptionalValues[index]?.value;
        if(this._utilityService.isEmptyOrUndefined(value) && value?.length === 0 && this.getFieldType(this.filterOptionalValues[index]?.key) ==='LOOKUP'){
            this.currentField = this.filterOptionalValues[index];
            this.presetInputList(this.filterOptionalValues[index]);
        }
    }

    get defaultDateRange(): any {
        return [{
            key: `${this._utilityService.getLocaleValue('daterange.range.today.label', 'Today')}`,
            rangeKey: 'TODAY',
            value: [dayjs()]
        },
        {
            key: `${this._utilityService.getLocaleValue('daterange.range.yesterday.label', 'Yesterday')}`,
            rangeKey: 'YESTERDAY',
            value: [dayjs().subtract(1, 'days')]
        },
        {
            key: `${this._utilityService.getLocaleValue('text.tomorrow', 'Tomorrow')}`,
            rangeKey: 'TOMORROW',
            value: [dayjs().add(1, 'days')]
        },
        {
            key: `${this._utilityService.getLocaleValue('daterange.range.seven.days.label', 'Last 7 Days')}`,
            rangeKey: 'LAST_7_DAYS',
            value: [dayjs().subtract(7, 'days'), dayjs().subtract(1, 'days')]
        },
        {
            key: `${this._utilityService.getLocaleValue('text.next.seven.days', 'Next 7 Days')}`,
            rangeKey: 'NEXT_7_DAYS',
            value: [dayjs().add(1, 'days'), dayjs().add(7, 'days')]
        },
        {
            key: `${this._utilityService.getLocaleValue('daterange.range.thirty.days.label', 'Last 30 Days')}`,
            rangeKey: 'LAST_30_DAYS',
            value: [dayjs().subtract(30, 'days'), dayjs().subtract(1, 'days')]
        },
        {
            key: `${this._utilityService.getLocaleValue('daterange.range.thismonth.label', 'This Month')}`,
            rangeKey: 'THIS_MONTH',
            value: [dayjs().startOf('month'), dayjs().endOf('month')]
        },
        {
            key: `${this._utilityService.getLocaleValue('daterange.range.lastmonth.label', 'Last Month')}`,
            rangeKey: 'LAST_MONTH',
            value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')]
        },
        {
            key: `${this._utilityService.getLocaleValue('daterange.range.nextmonth.label', 'Next Month')}`,
            rangeKey: 'NEXT_MONTH',
            value: [dayjs().add(1, 'month').startOf('month'), dayjs().add(1, 'month').endOf('month')]
        },
        {
            key: `${this._utilityService.getLocaleValue('daterange.range.nextthirtydays.label', 'Next Month')}`,
            rangeKey: 'NEXT_30_DAYS',
            value: [dayjs().add(1, 'days'), dayjs().add(30, 'days')]
        },
        {
            key: `${this._utilityService.getLocaleValue('text.custom.date', 'Custom Date')}`,
            rangeKey: 'CUSTOM_DATE',
            value: ['CUSTOM_DATE']
        },
        {
            key: `${this._utilityService.getLocaleValue('text.custom_range', 'Custom Range')}`,
            rangeKey: 'CUSTOM_RANGE',
            value: ['CUSTOM_RANGE']
        }];
    }

    OnRangeChange(field: any,index: any): any{
        if(!['CUSTOM_DATE','CUSTOM_RANGE'].includes(field.rangeKey) && !this._utilityService.isEmptyOrUndefined(field.rangeKey)){
            if(field?.operator === 'BETWEEN'){
                field.value = [dayjs(this.defaultDateRange.find((data: any)=>data.rangeKey === field?.rangeKey)?.value[0]).format('YYYY-MM-DD'),dayjs(this.defaultDateRange.find((data: any)=>data.rangeKey === field?.rangeKey)?.value[1]).format('YYYY-MM-DD')];
            }else{
                field.value = [dayjs(this.defaultDateRange.find((data: any)=>data.rangeKey === field?.rangeKey)?.value[0]).format('YYYY-MM-DD')];
            }
        }else{
            field.value = "";
        }
        console.log(field.value)
        this.filterOptionalValues[index] = this.setPrepopulatedOptionalValue(field,index);
        this.setFilterComponentEmitValue('apply');
    }

    ngOnChanges(changes: SimpleChanges): void {
        if('additionalFilters' in changes){
            this.additionalFilters = changes['additionalFilters']?.currentValue;
            this.filterOptionalValues.forEach((field: any)=>{
                if(field?.key === this.additionalFilters?.key && this._utilityService.isEmptyOrUndefined(field?.filterKey?.filter)){
                    field.filterKey = this.additionalFilters
                }
                return field;
            });
        }
    }

    private presetInputList(field): any{
        const fieldObject = this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field.key);
        const fieldValueURL = fieldObject?.data.url;
        const querryKey = !this._utilityService.isEmptyOrUndefined(field?.value) && field?.value?.length > 0 ? `filter.${fieldObject?.data?.dataKey}` : fieldObject?.data?.searchParam;
        const valueKey = Array.isArray(field?.value) ? field?.value.toString() : field?.value;
        const dataUrl = `${this._dataCollectorService.baseurl()}${fieldValueURL}`;

        let paramObj = {
            page:1,
            [querryKey]:valueKey
        };
        if(this.module === 'JOB' && fieldObject?.fieldDataKey === 'status_uid' && fieldObject?.displayName === 'Job Status'){
            const categoryUID = this.filterOptionalValues?.find((data: any)=> data?.key === 'job_category_uid')?.value;
            paramObj = {
                'page':this.pageSize,
                'count': 100,
                'filter.category_uid': this.getCategoryUids(categoryUID),
            };
        }
        if(this.module === 'PROJECT' && fieldObject?.fieldDataKey === 'project_current_status.status_uid' && fieldObject?.displayName === 'Project Status'){
            const categoryUID = this.filterOptionalValues?.find((data: any)=> data?.key === 'project_category_uid')?.value;
            paramObj = {
                'page':this.pageSize,
                'count': 100,
                'filter.category_uid': this.getCategoryUids(categoryUID),
            };
        }
        if((!this._utilityService.isEmptyOrUndefined(field?.filterKey?.filter) || field?.filterKey?.filter && Object.keys(field?.filterKey?.filter)?.length > 0)){
            paramObj = {
                ...paramObj,
                ...field?.filterKey?.filter
            }
        }else if(!this._utilityService.isEmptyOrUndefined(this.additionalFilters) && Object.keys(this.additionalFilters)?.length > 0 && this.additionalFilters?.key === field?.key && Object.keys(this.additionalFilters?.filter)?.length > 0){
            paramObj = {
                ...paramObj,
                ...this.additionalFilters?.filter
            }
        }
        
        this._dataCollectorService.getData(dataUrl,paramObj).subscribe(
            (response: any)=>{
                const responseData = response?.data;
                this.totalPages = response?.total_pages;
                if(this.module === 'JOB' && fieldObject?.fieldDataKey === 'status_uid' && fieldObject?.displayName === 'Job Status'){
                const listData = [];
                responseData.forEach((element: any)=>{
                    const status = element?.job_statuses?.filter((jobstatus: any)=>{
                        if(this.currentSearchTerm && this.currentSearchTerm.length >= 0){
                            return jobstatus?.status_name.toLowerCase().includes(this.currentSearchTerm.toLowerCase());
                        }else{
                            return jobstatus;
                        }
                    }).map((data: any)=>({...data,category_uid: element?.category_uid,category_name: element?.category_name}));
                    listData.push(status);
                });
                field.listPreData = listData.flat();
                this.currentSearchTerm = '';
                this.changeDetectorRef.markForCheck();
                }else if(this.module === 'PROJECT' && fieldObject?.fieldDataKey === 'project_current_status.status_uid' && fieldObject?.displayName === 'Project Status'){
                    const listData = [];
                    responseData.forEach((element: any)=>{
                        const status = element?.project_statuses?.filter((projectstatus: any)=>{
                            if(this.currentSearchTerm && this.currentSearchTerm.length >= 0){
                                return projectstatus?.project_status_name.toLowerCase().includes(this.currentSearchTerm.toLowerCase());
                            }else{
                                return projectstatus;
                            }
                        }).map((data: any)=>({...data,category_uid: element?.category_uid,category_name: element?.category_name}));
                        listData.push(status);
                    });
                    field.listPreData = listData.flat();
                    this.currentSearchTerm = '';
                    this.changeDetectorRef.markForCheck();
                }else{
                    if(field?.listPreData?.length > 0){
                        field.listPreData = _.uniqBy([...field?.listPreData,...this.constructLookupList(fieldObject,response?.data)], fieldObject?.data?.dataKey);
                    }else{
                        field.listPreData = [...this.constructLookupList(fieldObject,response?.data)];
                    }
                    this.changeDetectorRef.markForCheck();
                }
                this.currentPreloadedValue = _.uniqBy([...this.currentPreloadedValue,...field.listPreData],fieldObject?.data?.dataKey);
                this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field.key).data.listValue$ = of(this.currentPreloadedValue);
                if(!this._utilityService.isEmptyOrUndefined(field?.value) && field?.value?.length > 0){
                    const preloadValue = _.cloneDeep({...field,value:''});
                    this.presetInputList(preloadValue);
                }
                this.loadLookupValues(field);
        });
    }
    private constructTemplateValue(template: string,record: any): any{
        const keyCheck = [...new Set(template.replace(/\{{/ig, '').replace(/\s/ig,'').split('}').map((data: any)=>data.replace(/\..*/ig,'')).filter((data: any)=>data !==''))];
        for(const key of keyCheck){
          if(this._utilityService.isEmptyOrUndefined(record[key])){
            record[key] = '';
            break;
          }
        }
        const templateFun = ld.template(template);
        return templateFun(record);
      }

    private loadLookupValues(field): any {
        const initialValue = field?.listPreData?.length ? field?.listPreData : [];
        this.lookupLoading = false;
        this.filterFieldOptions.find((data: any)=>data.fieldDataKey === field.key).data.listValue$ = concat(
            of(initialValue),field?.valueSubject$ ? field?.valueSubject$?.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            tap(() => this.lookupLoading = true),
            tap(() => this.changeDetectorRef.markForCheck()),
            switchMap((term: any) => {
                if(![null,undefined].includes(term)){
                return this.setListValue(field,term).pipe(
                    catchError(() => of(initialValue)),
                    tap(() => this.lookupLoading = false),
                    tap(() => this.changeDetectorRef.markForCheck())
                    );
                }else {
                    this.lookupLoading = false;
                    this.changeDetectorRef.markForCheck();
                    return initialValue;
                }
                })) : []
        );
    }
}
